import React from 'react';
import {Link} from "react-router-dom";

import TechnologySmallIcon from './technologySmallIcon.js'

interface TechnologyIconAndNameProps {
    technology: string;
    technologyURL: string;
    technologyIcon: string;
    title?: string;
}

export default function TechnologyIconAndName({technology, technologyURL, technologyIcon, title}: TechnologyIconAndNameProps) {

    // if title not defined ... use default title
    const realTitle = 
        (title && title.length > 0) ? 
            title :
            title=`${technology} market share and usage statistic`;

    return (
        <>
            <Link 
                to={`/technology/${technologyURL}`}
                className="link-hover" 
                title={realTitle}
            >
                <TechnologySmallIcon
                    technologyIcon={technologyIcon}
                    technology={technology}
                />
                {' '}{technology}
            </Link>                                                    
        </>)
}
